import {getResults, hideResults} from './info-objects'

function modalAuthorization() {
	$('.js-open-authorization').on('click',function(){
		openAuthorizationModal();
	});
	$('.js-close-authorization, .wrap-modal__overlay').on('click', closeAuthorizationModal);
	$('.js-login').on('click', function() {
		let provider = $(this).data('provider');
		window.authSuccess = (user) => {
			showUserPanel(user);
			closeAuthorizationModal();
			window.isAuthorized = true;
			if (window.authCallback) {
				window.authCallback();
			} else {
				getResults();
			}
		};
		window.open('/auth?provider=' + provider, 'publicAuth', 'titlebar,close,width=1000,height=600');
	});
	$('.js-logout').on('click', function() {
		$.post('/handlers/public-auth', {action: 'logout'}, function(r) {
			if (r.status) {
				hideUserPanel();
				hideResults();
				window.isAuthorized = false;
			}
		}, 'json');
	});
}

function showUserPanel(user) {
	$('.app-authorization').addClass('app-authorization--active');
}

function hideUserPanel() {
	$('.app-authorization').removeClass('app-authorization--active');
}

export function openAuthorizationModal() {
	let Modal = $('.wrap-modal');
	if (!Modal.length) {
		return false;
	}
	Modal.fadeIn();
}

function closeAuthorizationModal() {
	let Modal = $('.wrap-modal');
	if (!Modal.length) {
		return false;
	}
	Modal.fadeOut();
}

function init() {
	modalAuthorization();
}

export default {
	init,
	openAuthorizationModal,
}
